

export const FORM_NAMES_KEY = {
    //SPOC
    SPOC: 'SPOCComms',
    SPOC_UPDATE_EMAIL: 'GetSpocUpdateEmail',
    SPOC_UPDATE_SMS: 'GetSpocUpdateSMS',
    SPOC_UPDATE_WHATSAPP: "GetSpocUpdateWhatsApp",
    //DOCTOR
    DOCTOR: 'Doctor',
    DOCTOR_UPDATE_EMAIL: 'GetDoctorUpdateEmail',
    DOCTOR_UPDATE_SMS: 'GetDoctorUpdateSMS',
    DOCTOR_UPDATE_WHATSAPP: 'GetDoctorUpdateWhatsApp',
    //APPOINTMENT
    APPOINTMENT: 'Appointment',
    APPOINTMENT_UPDATE_EMAIL: 'GetOrderUpdateEmail',
    APPOINTMENT_UPDATE_SMS: 'GetOrderUpdateSMS',
    APPOINTMENT_UPDATE_WHATSAPP: 'GetOrderUpdateWhatsApp',


    //LABS_ACTIVE
    LABS_ACTIVE: 'selectLabsActive',
    OPD_ACTIVE: 'selectOPDActive',
    VISION_ACTIVE: 'selectVisionActive',

    ACCESS_LEVEL: 'accessLevel',
    OFC_SPECIALITY: 'OFCspecicality',
    LAB_SPECIALITY: 'labsSpecicality',
    VISION_SPECIALITY: 'Vision',
    LABS_SERVICE: 'LABS',
    OPD_SERVICE: 'OFC',
    VISION_SERVICE: 'VISION',

    SELCTED_SERVICES:'selectedServices',

    COMMSELECTION:'commsSelection'

}

export const RBAC_UNAUTHORIZED_MESSAGE = "You are not Authorized for this action";

export const ACCESS_LEVEL_ARRAY = ['admin', 'editor', 'viewer'];


export const LABS_SERVICES = [
  { label: "Annual Health Checkup", value: "Annual Health Checkup" },
  { label: "Individual Test", value: "Individual Test" },
  { label: "Insurance", value: "Insurance" }
];


  export const Access_Level = [
    { title: "Admin", value: "admin" },
    { title: "Editor", value: "editor" },
    { title: "Viewer", value: "viewer" }
  ]

  export const INCLINIC = 'Inclinic';
  export const OFFLINE = 'Offline';
  export const SPOC_VIDEO_URL = "https://views.medibuddy.in/SPOC_Management_Provider_Central.mp4"